// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"424":"198e5d98","631":"eafbe2e6"}[chunkId] + ".chunk.js";
};